import { useNavigator } from '@repo/toolkit/use-navigator'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

type Section = {
  label: string
  path: string
  disabled?: boolean
}

type UseNavigateSectionsProps = {
  sections: Section[]
  allowNavigation?: boolean
}

export const useNavigateSections = ({
  sections,
  allowNavigation = true
}: UseNavigateSectionsProps) => {
  const [activeTab, setActiveTab] = useState(0)
  const { navigate } = useNavigator()
  const { pathname } = useLocation()

  useEffect(() => {
    sections.forEach((section, index) => {
      if (pathname.includes(section.path)) {
        setActiveTab(index)
      }
    })
  }, [pathname, sections])

  const handleTabChange = (index: number) => {
    if (!allowNavigation) {
      setActiveTab(index)
      return
    }

    navigate(sections[index].path, {
      replace: true
    })
  }

  return { activeTab, handleTabChange }
}
